import { Injectable } from "@angular/core";
import { AgreementPresenter } from "../presenter/agreement.presenter";

import { HttpErrorResponse } from "@angular/common/http";
import { AgreementService } from '../../../../../services/customers/agreement.service';
import { ClientsService } from '../../../../../services/customers/clients.service';
import { AgreementModel } from '../../../../../models/customers/agreement.model';
import { ProjectModel } from '../../../../../models/customers/project.model';
import { ProjectService } from '../../../../../services/customers/project.service';
import { ToastrService } from "ngx-toastr";




@Injectable({providedIn:'root'})
export class AgreementInteractor {

private _presenter: AgreementPresenter;

constructor(private agreementService: AgreementService,
            private toastr: ToastrService,
            private projectService: ProjectService,
            private clientsService: ClientsService) { }

setPresenter(presenter: AgreementPresenter):void{
  this._presenter = presenter;
}

async getAgreements(): Promise<AgreementModel[]> {
  const resp = await this.agreementService.getAllAsync()
                                          .then(res => res)
                                          .catch(err => err);
  if (resp.ok) {
      this._presenter.isRequestComplete(resp.ok, null, resp);
      return resp.clients;
  }
  this._presenter.isRequestComplete(false, resp);
  return [];
}


async getMasterAgreements() : Promise<AgreementModel[]> {
    const resp = await this.agreementService.getMasterAgreements();
    
    if(resp.ok){
       this._presenter.isRequestComplete(resp.ok, null, resp);
       return resp.agreements;
    }

    this._presenter.isRequestComplete(false, resp);
    return [];
}


newAgreement(agreement: FormData): void{
  this.agreementService.add(agreement)
              .subscribe(
                   (resp: any) => {
                   this._presenter.getResponse(resp);
                  },
                  (err: HttpErrorResponse) => this._presenter.isRequestComplete(false, err)
                );
}

editAgreement(agreement: AgreementModel): void{
  this.agreementService.update(agreement, agreement._id)
              .subscribe(
                   (resp: any) => {
                   this._presenter.isEditedResponseSuccess();
                   //console.log("editAgreement", resp)
                  },
                  (err: HttpErrorResponse) => this._presenter.isRequestComplete(false, err)
                );
}

async getClientInfo(id: string): Promise<any> {
  const resp = await this.clientsService.getAsyncById( id )
                                        .then(res => res)
                                        .catch(err => err);
  if (resp.ok) {
      return resp.client;
  }
  this._presenter.isRequestComplete(false, resp);
  return null;
}

newProject(project: ProjectModel): Promise<ProjectModel> {
  return new Promise((resolve, reject) => {

    this.projectService.add(project).subscribe(
    respProject => {
      this._presenter.isCreateProjectResponse(respProject)
      resolve(respProject.project)
      //console.log("newProject", respProject)
      this.toastr.success(respProject['msg']);
    },
    err => {
      this._presenter.isRequestComplete(false, err);
      reject()
      }
  );


});
}


getProject(id:any): Promise<ProjectModel> {
  return new Promise<ProjectModel>((resolve, reject) => {
    this.projectService.getProjectByGuid(id).subscribe({
      next: (project: ProjectModel) => {
        resolve(project)
      }
    })
  })
}


}
